/**
 * Shared SVG gradient definitions for board road sections
 *
 * Provides reusable gradient components that use centralized color constants.
 */

import { ROAD_COLORS } from './constants/colors';

interface GradientProps {
  id: string;
  x1: string;
  y1: string;
  x2: string;
  y2: string;
}

export function GreenDarkGradient({ id, x1, y1, x2, y2 }: GradientProps) {
  return (
    <linearGradient id={id} x1={x1} y1={y1} x2={x2} y2={y2} gradientUnits="userSpaceOnUse">
      <stop stopColor={ROAD_COLORS.gradients.greenDark.start} />
      <stop offset="1" stopColor={ROAD_COLORS.gradients.greenDark.end} />
    </linearGradient>
  );
}

export function GreenLightGradient({ id, x1, y1, x2, y2 }: GradientProps) {
  return (
    <linearGradient id={id} x1={x1} y1={y1} x2={x2} y2={y2} gradientUnits="userSpaceOnUse">
      <stop stopColor={ROAD_COLORS.gradients.greenLight.start} />
      <stop offset="1" stopColor={ROAD_COLORS.gradients.greenLight.end} />
    </linearGradient>
  );
}

export function BrownGroundGradient({ id, x1, y1, x2, y2 }: GradientProps) {
  return (
    <linearGradient id={id} x1={x1} y1={y1} x2={x2} y2={y2} gradientUnits="userSpaceOnUse">
      <stop stopColor={ROAD_COLORS.gradients.brownGround.start} />
      <stop offset="1" stopColor={ROAD_COLORS.gradients.brownGround.end} />
    </linearGradient>
  );
}

export function GrassOverlayGradient({ id, x1, y1, x2, y2 }: GradientProps) {
  return (
    <linearGradient id={id} x1={x1} y1={y1} x2={x2} y2={y2} gradientUnits="userSpaceOnUse">
      <stop stopColor={ROAD_COLORS.gradients.grassOverlay.start} />
      <stop offset="1" stopColor={ROAD_COLORS.gradients.grassOverlay.end} />
    </linearGradient>
  );
}

export function YellowStretchGradient({ id, x1, y1, x2, y2 }: GradientProps) {
  return (
    <linearGradient id={id} x1={x1} y1={y1} x2={x2} y2={y2} gradientUnits="userSpaceOnUse">
      <stop stopColor={ROAD_COLORS.gradients.yellowStretch.start} />
      <stop offset="0.52" stopColor={ROAD_COLORS.gradients.yellowStretch.middle} />
      <stop offset="1" stopColor={ROAD_COLORS.gradients.yellowStretch.end} />
    </linearGradient>
  );
}
